import { createAction, props } from '@ngrx/store';
import { GeneratedFilesResponse } from '../models/document-request-batch.models';

export const downloadGeneratedFiles = createAction('[DocumentRequestBatch] downloadGeneratedFiles', props<{ batchId: string }>());

export const downloadClientGeneratedFiles = createAction('[DocumentRequestBatch] downloadClientGeneratedFiles');

export const downloadClientGeneratedFilesSuccess = createAction(
  '[DocumentRequestBatch] downloadClientGeneratedFilesSuccess',
  props<{ response: GeneratedFilesResponse }>()
);

export const downloadClientGeneratedFilesError = createAction(
  '[DocumentRequestBatch] downloadClientGeneratedFilesError',
  props<{ error: string }>()
);

export const downloadGeneratedFilesSuccess = createAction(
  '[DocumentRequestBatch] downloadGeneratedFilesSuccess',
  props<{ response: GeneratedFilesResponse }>()
);

export const downloadGeneratedFilesError = createAction('[DocumentRequestBatch] downloadGeneratedFilesError', props<{ error: string }>());
